import { memo } from 'react';

function BotIconSuccess() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#9CA3AF"
        fillRule="evenodd"
        d="M10 1.875c-1.034 0-1.875.84-1.875 1.875 0 1.034.84 1.875 1.875 1.875 1.034 0 1.875-.84 1.875-1.875 0-1.034-.84-1.875-1.875-1.875zm0 1.25a.625.625 0 110 1.25.625.625 0 010-1.25z"
        clipRule="evenodd"
      />
      <path
        fill="#9CA3AF"
        fillRule="evenodd"
        d="M16.875 9.75v-3c0-1.034-.84-1.875-1.875-1.875H5c-1.035 0-1.875.84-1.875 1.875v7.5c0 1.035.84 1.875 1.875 1.875h5c1.035 0 1.5.41 1.5-.625 0-.345-.155 0-.5 0s-.552-.75-.5-1c0 .345-.155.375-.5.375H5a.625.625 0 01-.625-.625v-7.5c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625v3a.625.625 0 101.25 0z"
        clipRule="evenodd"
      />
      <path
        fill="#9CA3AF"
        fillRule="evenodd"
        d="M7.5 7.375c-1.034 0-1.875.84-1.875 1.875 0 1.034.84 1.875 1.875 1.875 1.034 0 1.875-.84 1.875-1.875 0-1.034-.84-1.875-1.875-1.875zm0 1.25a.625.625 0 110 1.25.625.625 0 010-1.25zM12.5 7.375c-1.034 0-1.875.84-1.875 1.875 0 1.034.84 1.875 1.875 1.875 1.034 0 1.875-.84 1.875-1.875 0-1.034-.84-1.875-1.875-1.875zm0 1.25a.625.625 0 110 1.25.625.625 0 010-1.25zM18.75 7.625A.625.625 0 0018.125 7H16.25a.625.625 0 00-.625.625v2.5c0 .345.28.625.625.625h1.875c.345 0 .625-.28.625-.625v-2.5zm-1.875.625V9.5h.625V8.25h-.625zM4.375 7.625A.625.625 0 003.75 7H1.875a.625.625 0 00-.625.625v2.5c0 .345.28.625.625.625H3.75c.345 0 .625-.28.625-.625v-2.5zM2.5 8.25V9.5h.625V8.25H2.5zM8.75 13.625h2.5a.625.625 0 100-1.25h-2.5a.625.625 0 100 1.25z"
        clipRule="evenodd"
      />
      <path stroke="#20BF6B" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.67" d="M10 15l3 3 6-6" />
    </svg>
  );
}

export default memo(BotIconSuccess);
